<template>
  <div id="banner">
    <b-container class="bv-example-row">
      <b-row>
        <b-col sm="12" md="6" class="d-flex align-items-center">
          <div class="banner-left-content">
            <h1>
              <span>
                Ever wondered <b>what people think</b> of your presentations?
              </span>
            </h1>
            <p class="banner-content-p">
              <span>
                Get specific feedback with action steps to take your presentation
                skills — and your career — to the next level
              </span>
            </p>
            <br />
            <div class="d-none d-md-block">
              <TMGeneralButton text="SEE HOW IT WORKS" route="HowItWorks" />
            </div>
          </div>
        </b-col>
        <b-col sm="12" md="6" class="pt-3">
          <div class="banner-img-container">
              <img class="img-fluid banner-img" src="/img/home/banner-speaker.png" />
              <img class="banner-img-yellow" src="/img/home/yellow.png" />
          </div>
        </b-col>
      </b-row>
      <b-row class="d-md-none">
        <b-col>
          <div class="banner-cta-container">
              <TMGeneralButton text="SEE HOW IT WORKS" route="HowItWorks" />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="banner-get-started mt-md-4">
            <b-row>
              <b-col sm="12" md="7">
                <p>
                  Transform yourself into a more confident, engaging and
                  persuasive presenter
                </p>
              </b-col>
              <b-col sm="12" md="5" class="text-center">
                <TMGeneralButton
                  text="GET STARTED"
                  route="GetStarted"
                  className="blue"
                />
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import TMGeneralButton from "@/components/common/TMGeneralButton";
export default {
  name: "Banner",
  components: {
    TMGeneralButton,
  },
};
</script>
<style lang="less" >
@import "../../assets/components/home/Banner.less";
</style>;
